<template>
  <div>
    <v-dialog
      v-model="verModal"
      width="1200"
    >
      <section class="grey darken-1">
        <div style="display: flex;align-items:center;" class="py-2 px-4 white">
          <h2 class="primary--text">
            <v-icon color="primary">document_scanner</v-icon>&nbsp;&nbsp;{{ pTitulo }}
          </h2>
          <v-spacer />
          <v-btn icon @click="clicCerrarPdf()">
            <v-icon color="primary" large>close</v-icon>
          </v-btn>
        </div>
        <iframe
          :src="pUrlArchivoPdf"
          type="application/pdf"
          scrolling="yes"
          style="overflow:hidden; height: 700px; width: 100%;"
        />
      </section>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'PdfVista',
  components: {
  },
  props: {
    pUrlArchivoPdf: {
      type: String,
      default: ''
    },
    pVerModal: { type: Boolean,default: false },
    pTitulo: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    verModal: false,
  }),
  watch: {
    pVerModal(val) {
      this.verModal = this.pVerModal
    },
    verModal(val) {
      this.$emit('update:pVerModal', val)
    }
  },
  mounted(){
    this.verModal = this.pVerModal
  },
  methods: {
    clicCerrarPdf() {
      this.$emit('emitCerrarVistaPdf')
    }
  },
}
</script>
